package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.DpOffset
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.appCore.logic.pages.StaffListViewModel
import com.example.mystybag.appCore.views.components.ClientWebHeaderBar
import com.example.mystybag.appCore.views.components.WebHeaderBottomDivider
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.extensions.scrollEdgeFade
import com.example.mystybag.common.ui.components.custom.KeyboardArrowDownIcon
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.CaptionCapitalization
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.extensions.noRippleClickable
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.expected.rememberIsWebDesktopLayout
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.ui.theme.LocalTheme.p10
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p40
import com.example.mystybag.core.ui.theme.LocalTheme.p56
import com.example.mystybag.core.ui.theme.LocalTheme.p100
import com.example.mystybag.core.ui.theme.LocalTheme.p0
import com.example.mystybag.core.ui.theme.LocalTheme.p1
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantStaffItemResponse
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import dev.icerock.moko.resources.compose.painterResource
import androidx.compose.foundation.layout.PaddingValues

@Composable
fun StaffListView(viewModel: StaffListViewModel) {
    val uiState by viewModel.uiState.subscribeAsState()

    if (rememberIsWebDesktopLayout()) {
        StaffListWebView(viewModel = viewModel, uiState = uiState)
        return
    }

    UIView(viewModel = viewModel) {
        StaffListContent(viewModel = viewModel, uiState = uiState, modifier = Modifier.fillMaxSize())
    }
}

@Composable
private fun StaffListWebView(
    viewModel: StaffListViewModel,
    uiState: com.example.mystybag.appCore.model.pages.StaffListUIState
) {
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        showTopBar = false,
        removeVerticalPadding = true
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            ClientWebHeaderBar(
                selectedTab = 3,
                homeTabIndex = 0,
                deliveryTabIndex = 1,
                favoritesTabIndex = 2,
                menuTabIndex = 3,
                searchCallbacks = null,
                onFilterClick = {},
                showSearchAndFilter = false,
                showBackButton = true,
                onBackClick = { viewModel.navCallbacks.backButtonCallback() }
            )
            WebHeaderBottomDivider()
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
                contentAlignment = Alignment.TopCenter
            ) {
                StaffListContent(
                    viewModel = viewModel,
                    uiState = uiState,
                    modifier = Modifier
                        .width(1080.dp)
                        .fillMaxHeight()
                        .padding(horizontal = p16, vertical = p8)
                )
            }
        }
    }
}

@Composable
private fun StaffListContent(
    viewModel: StaffListViewModel,
    uiState: com.example.mystybag.appCore.model.pages.StaffListUIState,
    modifier: Modifier
) {
    val colors = AppTheme.current.colors
    val isWebDesktop = rememberIsWebDesktopLayout()
    Box(modifier = modifier) {
        Box(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = p16)
                    .widthIn(max = 412.dp)
                    .align(Alignment.TopCenter)
            ) {
                when {
                    uiState.isLoading -> {
                        CircularProgressIndicator(modifier = Modifier.align(Alignment.CenterHorizontally))
                    }
                    else -> {
                        var locationMenuExpanded by remember { mutableStateOf(false) }
                        val filterLabel = if (uiState.selectedLocationId == null) {
                            sharedString(SR.strings.all_locations)
                        } else {
                            uiState.locations.find { it.id == uiState.selectedLocationId }?.title
                                ?: sharedString(SR.strings.all_locations)
                        }

                        Column(modifier = Modifier.fillMaxSize()) {
                        // Location filter chip – clickable dropdown
                        BoxWithDropdown(
                            filterLabel = filterLabel,
                            colors = colors,
                            expanded = locationMenuExpanded,
                            onExpandedChange = { locationMenuExpanded = it },
                            onSelectAllLocations = {
                                viewModel.setSelectedLocationId(null)
                                locationMenuExpanded = false
                            },
                            locations = uiState.locations,
                            selectedLocationId = uiState.selectedLocationId,
                            onSelectLocation = { id ->
                                viewModel.setSelectedLocationId(id)
                                locationMenuExpanded = false
                            }
                        )

                        Spacer(modifier = Modifier.height(p16))

                        if (uiState.filteredStaff.isEmpty()) {
                            Texts.BodyMedium(
                                text = sharedString(SR.strings.no_staff),
                                modifier = Modifier
                                    .weight(1f)
                                    .align(Alignment.CenterHorizontally),
                                color = colors.onSurfaceVariant
                            )
                        } else {
                            LazyColumn(
                                modifier = Modifier
                                    .weight(1f)
                                    .scrollEdgeFade(showTop = false),
                                verticalArrangement = Arrangement.spacedBy(p16)
                            ) {
                                items(uiState.filteredStaff, key = { it.id }) { staff ->
                                    StaffCard(
                                        staff = staff,
                                        onClick = { viewModel.navigateToEditEmployee(staff.id) }
                                    )
                                }
                            }
                        }

                        Spacer(modifier = Modifier.height(p16))

                        // Add employee button – Figma: 380x56, cornerRadius 100, Primary
                        DefaultButton(
                            modifier = Modifier
                                .fillMaxWidth(if (isWebDesktop) 0.5f else 1f)
                                .align(Alignment.CenterHorizontally)
                                .height(p56)
                                .padding(horizontal = if (isWebDesktop) 0.dp else p16)
                                .padding(bottom = if (isWebDesktop) 32.dp else p8),
                            caption = sharedString(SR.strings.add_employee),
                            capitalization = CaptionCapitalization.None,
                            contentPadding = if (isWebDesktop) PaddingValues(horizontal = p16, vertical = 0.dp) else null,
                            callback = { viewModel.navigateToAddEmployee() },
                        )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun BoxWithDropdown(
    filterLabel: String,
    colors: androidx.compose.material3.ColorScheme,
    expanded: Boolean,
    onExpandedChange: (Boolean) -> Unit,
    onSelectAllLocations: () -> Unit,
    locations: List<MerchantLocationResponseModel>,
    selectedLocationId: Long?,
    onSelectLocation: (Long) -> Unit
) {
    Box(modifier = Modifier.padding(top = p8)) {
        Row(
            modifier = Modifier
                .height(p40)
                .background(
                    color = colors.surfaceContainerLowest,
                    shape = RoundedCornerShape(p100)
                )
                .padding(horizontal = p16, vertical = p10)
                .noRippleClickable { onExpandedChange(true) },
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(p8)
        ) {
            Texts.BodyMedium(
                text = filterLabel,
                color = colors.onSurface
            )
            KeyboardArrowDownIcon(
                contentDescription = null,
                tint = colors.onSurface,
                fontSize = 12.sp
            )
        }
        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { onExpandedChange(false) },
            containerColor = colors.surface,
            shape = RoundedCornerShape(p20),
            offset = DpOffset(x = 0.dp, y = 4.dp),
            modifier = Modifier.heightIn(max = 320.dp)
        ) {
            DropdownMenuItem(
                text = { Texts.BodyMedium(text = sharedString(SR.strings.all_locations), color = colors.onSurface) },
                onClick = onSelectAllLocations
            )
            if (locations.isNotEmpty()) {
                HorizontalDivider(thickness = 1.dp, color = colors.outline)
            }
            locations.forEachIndexed { index, location ->
                DropdownMenuItem(
                    text = { Texts.BodyMedium(text = location.title ?: "", color = colors.onSurface) },
                    onClick = { onSelectLocation(location.id) }
                )
                if (index < locations.lastIndex) {
                    HorizontalDivider(thickness = 1.dp, color = colors.outline)
                }
            }
        }
    }
}

@Composable
private fun StaffCard(
    staff: MerchantStaffItemResponse,
    onClick: () -> Unit = {}
) {
    val colors = AppTheme.current.colors

    Card(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .border(width = p1, color = colors.outline, shape = RoundedCornerShape(p20)),
        shape = RoundedCornerShape(p20),
        colors = CardDefaults.cardColors(containerColor = colors.surface),
        elevation = CardDefaults.cardElevation(defaultElevation = p0)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(p20),
            horizontalArrangement = Arrangement.spacedBy(p16),
            verticalAlignment = Alignment.Top
        ) {
            // Left content – Frame 26080512: name, email, phone, role with 4dp spacing
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(p4)
            ) {
                val name = listOfNotNull(staff.firstName, staff.lastName).filter { it.isNotEmpty() }.joinToString(" ")
                if (name.isNotEmpty()) {
                    Texts.TitleMedium(
                        text = name,
                        color = colors.onSurface
                    )
                }
                val email = staff.email
                if (email != null && email.isNotEmpty()) {
                    Texts.BodyMedium(text = email, color = colors.onSurfaceVariant)
                }
                val phone = listOfNotNull(staff.dialCode, staff.phoneNumber).filter { it.isNotEmpty() }.joinToString(" ")
                if (phone.isNotEmpty()) {
                    Texts.BodyMedium(text = phone, color = colors.onSurfaceVariant)
                }
                val role = staff.role
                if (role != null && role.isNotEmpty()) {
                    Texts.BodyMedium(
                        text = when (role) {
                            "OWNER" -> com.example.mystybag.core.expected.sharedString(SR.strings.role_owner)
                            "MANAGER" -> com.example.mystybag.core.expected.sharedString(SR.strings.role_manager)
                            else -> com.example.mystybag.core.expected.sharedString(SR.strings.role_staff)
                        },
                        color = colors.onSurfaceVariant
                    )
                }
            }

            // Edit button – Frame 135373: 40x40 circle, Surface Container Lowest bg, 20x20 pencil icon
            Row(
                modifier = Modifier
                    .size(p40)
                    .background(color = colors.surfaceContainerLowest, shape = CircleShape),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    painter = painterResource(SRC.images.staff_edit_icon),
                    contentDescription = sharedString(SR.strings.edit_short),
                    contentScale = ContentScale.Fit,
                    modifier = Modifier.size(p20)
                )
            }
        }
    }
}
